import Loadable from '../../components/loadable';

const EditTask = Loadable({
  loader: () => import('../../pages/tasks/edit_task'),
  type: 'drawer',
});

angular.module('shared').value('EditTask', EditTask);
